import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgModule} from "@angular/core";

import {PopoverModule} from "ngx-popover";
import { UsuarioService } from "../../../_seguridad/_usuario/usuario.service";

import {CollapseMenuComponent} from "./collapse-menu/collapse-menu.component";
import {RecentProjectsComponent} from "./recent-projects/recent-projects.component";
import {FullScreenComponent} from "./full-screen/full-screen.component";
import {ChangePasswordComponent} from "./change-password/change-password.component";

import {ActivitiesComponent} from "./activities/activities.component";
import {ActivitiesMessageComponent} from "./activities/activities-message/activities-message.component";
import {ActivitiesNotificationComponent} from "./activities/activities-notification/activities-notification.component";
import {ActivitiesTaskComponent} from "./activities/activities-task/activities-task.component";
import {HeaderComponent} from "./header.component";

import {UtilsModule} from "../../utils/utils.module";
import { SpeechButtonComponent } from './speech-button/speech-button.component';
import {I18nModule} from "../../i18n/i18n.module";
import {UserModule} from "../../user/user.module";
import {VoiceControlModule} from "../../voice-control/voice-control.module";
import {BsDropdownModule} from "ngx-bootstrap";

import {SmartadminValidationModule} from "../../../shared/forms/validation/smartadmin-validation.module";
import {SmartadminInputModule} from "../../../shared/forms/input/smartadmin-input.module";
import { DirectiveModule } from '../../../shared/utils/directives/directives.module';


@NgModule({
  imports: [
    CommonModule,

    FormsModule,

    VoiceControlModule,

    BsDropdownModule,

    UtilsModule, I18nModule, UserModule, PopoverModule,
    SmartadminValidationModule, SmartadminInputModule, DirectiveModule

  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    FullScreenComponent,
    ChangePasswordComponent,
    CollapseMenuComponent,
    ActivitiesComponent,
    HeaderComponent,
    SpeechButtonComponent,
  ],
  exports: [
    HeaderComponent
  ],
  providers: [
    UsuarioService
  ]
})
export class HeaderModule{}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.module.ts